import React from 'react';
import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import {pushHomeCreator} from '../Store/Home/Actions';

interface CrumbProps {
  to: string;
  children?: React.ReactNode;

  pushHome: () => Promise<void>;
}

function Crumb({to, pushHome, children}: CrumbProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    pushHome();
  };

  return (
    <a className="crumb" href={to} onClick={handleClick}>{children}</a>
  );
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>)  => {
  return {
    pushHome: () => dispatch(pushHomeCreator()),
  };
};

export default connect(undefined, mapDispatchToProps)(Crumb);
